export default function DownIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_408_35163)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M7.72 9.97a.75.75 0 0 1 1.06 0L12 13.19l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
}
